import { Input as AntInput, InputNumber as AntInputNumber } from 'antd';
import styled from 'styled-components';

export const Input = styled(AntInput)`
  &.task-duration-input {
    max-width: 81px;
  }
`;

export const InputNumber = styled(AntInputNumber)`
  .ant-input-number-input {
    line-height: 20px;
  }
`;

export const InputSearch = styled(AntInput.Search)`
  font-weight: 400;
  .ant-input-affix-wrapper {
    &:not(:last-child) {
      border-radius: 5px;
    }
    .ant-input-prefix {
      font-size: 16px;
      margin-inline-end: 5px;
      color: var(--clr-general-description);
    }
    padding: 5px 10px;
  }
  .ant-input-group-addon {
    display: none;
  }
  .custom-clear-icon {
    font-size: 10px;
    color: var(--clr-general-description);
  }
  .ant-input::placeholder {
    font-size: 12px;
  }
`;

const TEXTAREA_LINE_HEIGHT = 17;
const TEXTAREA_VERTICAL_PADDING = 44;
const TEXTAREA_VERTICAL_BORDER = 2;

const resolveTextareaHeight = (rows: number) =>
  rows * TEXTAREA_LINE_HEIGHT + TEXTAREA_VERTICAL_PADDING + TEXTAREA_VERTICAL_BORDER;

export const InputTextarea = styled(AntInput.TextArea)<{ $resizeMinRows?: number }>`
  .ant-input {
    line-height: ${TEXTAREA_LINE_HEIGHT}px;
    font-size: 12px;
    padding: 10px 10px 34px;
    &::placeholder {
      line-height: 16px;
    }
  }
  /* Out-ranks antd's own min-height on the affix-wrapped textarea, which otherwise lets a drag shrink it to one line. */
  ${({ $resizeMinRows }) =>
    $resizeMinRows &&
    `
      &.ant-input-textarea-affix-wrapper.ant-input-affix-wrapper > textarea.ant-input {
        resize: vertical;
        min-height: ${resolveTextareaHeight($resizeMinRows)}px;
      }
    `}
  &.ant-input-affix-wrapper {
    .ant-input-suffix {
      z-index: 10;
      .ant-input-data-count {
        bottom: 10px;
        right: 10px;
        color: var(--clr-general-description);
        font-size: 10px;
        font-weight: 400;
        line-height: 100%;
        z-index: 9;
      }
    }
    &:not(.ant-input-disabled):hover,
    &.ant-input-affix-wrapper-focused,
    &:focus-within {
      z-index: auto;
    }
  }
  &.event-input {
    padding: 10px;
    resize: none;
    height: 100%;
  }
`;
